import { SITE_URL, SITE_NAME, SITE_DESCRIPTION, SITE_EMAIL, SITE_ADDRESS } from '../config/site';
import { visibleProducts } from './products';

export const companySummary = {
  name: SITE_NAME,
  url: SITE_URL,
  description: SITE_DESCRIPTION,
  email: SITE_EMAIL,
  address: SITE_ADDRESS,
  country: 'Philippines',
  region: 'Pampanga',
  founded: '2020',
  expertise: [
    'AI Integration',
    'Local AI Setup & Infrastructure',
    'Custom AI Development',
    'Enterprise Software',
    'Robotics Process Automation',
    'AI Analytics & Reporting',
  ],
  clients: ['Enterprise', 'SMEs', 'Government', 'Banks', 'Healthcare', 'Logistics'],
};

export const servicesSummary = [
  {
    name: 'AI Implementation',
    description: 'Deploy ready-to-use AI in your business within weeks with full setup and team training.',
  },
  {
    name: 'AI Setup & Infrastructure',
    description: 'Secure cloud, on-premise, or hybrid AI infrastructure built for performance and scale.',
  },
  {
    name: 'AI Analytics & Reports',
    description: 'Automated dashboards, insights, and scheduled reports powered by AI.',
  },
  {
    name: 'Robotics Process Automation',
    description: 'Software robots for repetitive tasks such as data entry, invoicing, and reporting.',
  },
  {
    name: 'Custom AI Development',
    description: 'Tailored AI applications, agents, and integrations for your workflows.',
  },
  {
    name: 'Cloud Security & Compliance',
    description: 'Security-first AI deployments with compliance and monitoring.',
  },
];

export const faqs = [
  {
    question: 'What is XDigital IT Consultancy?',
    answer: `${SITE_NAME} is a Philippine-based AI solutions provider specializing in AI integration, enterprise software, and custom AI products for businesses in the Philippines and Southeast Asia. The company is located in ${SITE_ADDRESS}.`,
  },
  {
    question: 'What AI products does XDigital offer?',
    answer: `XDigital offers 11 AI-powered enterprise products including Budget Management, Audit Management, Real Estate Valuation, Report Generator, Document Management, Tracker/Logistics, AI Receptionist Agent, AI Technical Support Agent, AI Sales Agent, AI Chatbot, and Project Management. Full details are at ${SITE_URL}/products.`,
  },
  {
    question: 'How do I contact XDigital for a demo or consultation?',
    answer: `Contact XDigital at ${SITE_EMAIL} or visit ${SITE_URL}/contact to schedule a consultation, product demo, or AI strategy session.`,
  },
  {
    question: 'What services does XDigital provide besides products?',
    answer: `Services include AI implementation, AI infrastructure setup, AI analytics, robotics process automation (RPA), custom AI development, and cloud security. See ${SITE_URL}/services for details.`,
  },
  {
    question: 'What industries does XDigital serve?',
    answer: 'XDigital serves banks, insurance, healthcare, logistics, real estate, government, hospitality, legal, manufacturing, and general enterprise businesses across the Philippines.',
  },
  {
    question: 'How do I get a quote for XDigital AI products?',
    answer: 'Contact XDigital at sales@xdigital.com.ph or visit the contact page to request a custom quote tailored to your business needs.',
  },
];

export function getProductSummaries() {
  return visibleProducts.map((product) => ({
    name: product.name,
    slug: product.slug,
    url: `${SITE_URL}/products#${product.slug}`,
    tagline: product.tagline,
    description: product.description,
    features: product.features,
    targetMarket: product.target_market,
  }));
}

export default {
  companySummary,
  servicesSummary,
  faqs,
  getProductSummaries,
};
